import store from '@/store'
export default (to, from, next) => {
  let restaurant = store.getters["location_selected/placeSelected"];
  let locale = store.getters["lang/locale"];
  window.location.href = process.env.VUE_APP_DOMAIN + "/restaurant/" + restaurant.slug + "?lang=" + locale;
}
